import { View } from './view'

export const EaseSavings = View
